var app = angular.module('leonardo');

var TemplateTriggerList = function (
  $scope,
  $filter,
  $timeout,
  $q,
  $controller,
  $stateParams,
  $rootScope,
  ngDialog,
  TemplateService,
  FilterService,
  $state,
  PermissionService,
  AccountUserService,
  AuthDataService,
  TemplateTriggerService
) {
  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.onboarding = $state.current.onboarding ? true : false;
  $scope.templates = [];
  $scope.templateService = TemplateService;
  $scope.options = [];

  $scope.isTypeAccount = function (template) {
    var type = $filter('templateType')(template);
    return type === 'A' || type === 'S';
  };

  $scope.submitActive = function (template) {
    if (!template) {
      return false;
    }
    if ($scope.onboarding) {
      return true;
    }
    if ($state.current.action === 'create') {
      return true;
    }
    return template.editable;
  };

  $scope.overrideActive = function (template) {
    if (!template) {
      return false;
    }
    if ($scope.onboarding) {
      return false;
    }
    if ($state.current.action === 'create') {
      return false;
    }
    return !template.editable && template.overridable;
  };

  $scope.deleteTemplate = function (template) {
    ngDialog
      .openConfirm({
        templateUrl: 'views/templates/dialog/template/delete.html',
        controller: 'DeletePresenterDialog',
        data: {
          object: template,
          type: 'template: ' + template.name
        }
      })
      .then(function (dialogData) {
        template.remove({ remove_children: dialogData ? dialogData.remove_children : false }).then(function () {
          $scope.loadPage($scope.page);
        });
      }, function () {
        return;
      });
  };

  $scope.goToAttachments = function (template) {
    $scope.showEditTemplate(template);
    $timeout(function () {
      angular.element('.ngdialog-template-add .ngdialog-content').animate(
        {
          scrollTop:
            angular.element('.ngdialog-template-add .ngdialog-content .wrapper-attachment').offset().top +
            angular.element('.ngdialog-template-add .ngdialog-content').scrollTop() -
            150
        },
        'slow'
      );
    }, 1500);
  };

  $scope.goToDynamicForm = function (template) {
    $scope.showEditTemplate(template);
    $timeout(function () {
      angular.element('.ngdialog-template-add .ngdialog-content').animate(
        {
          scrollTop:
            angular.element('.ngdialog-template-add .ngdialog-content .widget-dynamic-form-selector.form-item').offset().top +
            angular.element('.wrapper-columns-column.region-main .content-column').scrollTop() -
            150
        },
        'slow'
      );
    }, 1500);
  };

  $scope.disableToggleTemplate = function (template) {
    return !template.editable && !template.overridable;
  };

  $scope.anyRequired = function (templates) {
    var found = false;
    angular.forEach(templates, function (template) {
      if (template.required) {
        found = true;
      }
    });
    return found;
  };

  $scope.initUsers = function (users) {
    var userIds = [];
    angular.forEach(users, function (user) {
      if (user) {
        if (user.id) {
          userIds.push(user.id);
        } else {
          userIds.push(user);
        }
      }
    });
    return userIds;
  };

  $scope.getData = function (template) {
    var data = angular.copy(template);

    data.account_users_assigned = $scope.initUsers(data.account_users_assigned);
    data.notify_at_approval_complete_users = $scope.initUsers(data.notify_at_approval_complete_users);
    data.notify_at_approval_terminated_users = $scope.initUsers(data.notify_at_approval_terminated_users);

    data.notify_to = [];

    angular.forEach(template.notify_to, function (email) {
      if (email) {
        data.notify_to.push(email);
      }
    });

    data.contact_types = [];

    angular.forEach(template.contact_types, function (type) {
      if (type) {
        data.contact_types.push(type.id);
      }
    });

    data.attachments = [];
    angular.forEach(template.attachments, function (attachment) {
      data.attachments.push(attachment.id ? attachment.id : attachment);
    });

    if (template.managed_by) {
      data['managed_by'] = template.managed_by.id;
    }
    data.country = null;
    if (template.country) {
      data.country = (template.country.id ? template.country.id : template.country);
    }
    else {
      if (AuthDataService.authData.account) {
        data.country = (AuthDataService.authData.account.country.id ? AuthDataService.authData.account.country.id : AuthDataService.authData.account.country)
      }
    }
    data.levels = [];
    angular.forEach(template.levels, function (level) {
      if (level) {
        data.levels.push(level.id);
      }
    });
    data.roles = template.roles ? template.roles.map(item => item.id || item) : [];
    // approval steps data formatting
    if(data.approval_steps && data.approval_steps.length > 0) {
      data.approval_steps.forEach(step => {
        step.user_approvers = step.user_approvers ? $scope.initUsers(step.user_approvers) : [];
        step.user_role_approvers = step.user_role_approvers ? $scope.initUsers(step.user_role_approvers) : [];
        step.secondary_user_approvers = step.secondary_user_approvers ? $scope.initUsers(step.secondary_user_approvers) : [];
        step.secondary_user_role_approvers = step.secondary_user_role_approvers ? $scope.initUsers(step.secondary_user_role_approvers) : [];
      });
    }
    return data;
  };

  $scope.clone = function (template) {
    TemplateTriggerService.get(template.id).then(function (data) {
      var templateData = $scope.getData(data);
      if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
        TemplateTriggerService.post(templateData).then(function (temp) {
          $rootScope.$broadcast('template:created');
        });
      } else {
        templateData['type'] = TemplateService.TYPE_TRIGGER;
        templateData['account'] = AccountUserService.currentAccountUser.account;
        delete templateData['parent'];
        delete templateData['portfolio'];
        delete templateData['property'];
        TemplateTriggerService.post(templateData).then(function () {
          $rootScope.$broadcast('template-trigger:created');
        });
      }
    });
  };

  $scope.getParams = function (parent_id) {
    var filters = {};
    filters['sector'] = FilterService.getFilter('sector') ? FilterService.getFilter('sector') : AccountUserService.currentAccountUser.sector;
    filters['type'] = TemplateService.TYPE_TRIGGER;
    if (FilterService.hasFilter('status')) {
      filters['status'] = FilterService.getFilter('status');
    } else {
      filters['status'] = TemplateService.STATUS_PUBLISHED + ',' + TemplateService.STATUS_UNPUBLISHED;
    }

    filters['ancestor'] = parent_id;
    if (!parent_id) {
      filters['exclude_children'] = true;
    } else {
      filters['disable_pagination'] = true;
      $rootScope.$broadcast('disable_pagination', { disable_pagination: true });
    }

    if (FilterService.hasFilter('priority')) {
      filters['priority'] = FilterService.getFilter('priority');
    }

    if (FilterService.hasFilter('category')) {
      filters['category'] = FilterService.getFilter('category');
    }

    if (FilterService.hasFilter('template_name')) {
      filters['name__icontains'] = FilterService.getFilter('template_name');
    }

    if (FilterService.hasFilter('role')) {
      filters['roles'] = FilterService.getFilter('role');
    }

    return filters;
  };

  $scope.getProfundity = function () {
    var childTemplates = [];
    var templates = [];
    angular.forEach($scope.templates, function (template) {
      if (template.account_user) {
        AccountUserService.get(template.account_user, true).then(function (item) {
          template.user = item.user;
        });
      }
      if (!_.contains(childTemplates, template.id)) {
        template.depth = 0;
        templates.push(template);
        $scope.addChildren(templates, childTemplates, template, 1);
      }
    });
    return templates;
  };

  $scope.addChildren = function (templates, childTemplates, template, level) {
    angular.forEach(template.children, function (childId) {
      for (var i = templates.length - 1; i >= 0; i--) {
        if (templates[i].id === childId) {
          templates.splice(i, 1);
        }
      }
      childTemplates.push(childId);
      var child = $scope.templates.filter(function (obj) {
        return obj.id === childId;
      });
      if (child.length) {
        child = child[0];
        child.depth = level;
        templates.push(child);
        $scope.addChildren(templates, childTemplates, child, level + 1);
      }
    });
  };

  $scope.getPriorityColor = function (template) {
    if (template.priority !== null && template.priority !== undefined && template.priority !== '')
      switch (template.priority.toString()) {
        case TemplateService.PRIORITY_MINOR:
          return 'successColor';
        case TemplateService.PRIORITY_NORMAL:
          return 'warningColor';
        case TemplateService.PRIORITY_CRITICAL:
          return 'errorColor';
      }
    return '';
  };

  $scope.showEditTemplate = function (template) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/add-trigger.html',
        controller: 'TemplateTriggerAddDialog',
        className: 'ngdialog-theme-default ngdialog-template-add',
        data: {
          template: template,
          action: 'edit',
          follow_on: template.follow_on,
          workflow: template.workflow,
          account: AccountUserService.currentAccountUser.account
        }
      })
      .then(function () {
        $rootScope.$broadcast('template-trigger:created');
      }, function () {
        return;
      });
  };

  $scope.getEntitiesPromise = function (options) {
    var params = $scope.getParams($stateParams.id);
    angular.forEach(params, function (value, key) {
      options[key] = value;
    });
    if (!options['ordering']) {
      options['ordering'] = 'name,parent';
    } else {
      options['ordering'] += ',parent';
    }
    var defer = $q.defer();

    $scope.options = options;
    TemplateTriggerService.getlist(options).then(
      function (data) {
        $scope.templates = [];
        if ($scope.template_parent) {
          $scope.templates.push($scope.template_parent);
        }
        var results = data.results ? data.results : data;
        angular.forEach(results, function (value) {
          var exist = false;
          angular.forEach($scope.templates, function (value_aux) {
            if (value.id === value_aux.id) {
              exist = true;
            }
          });
          if (!exist) {
            $scope.templates.push(value);
          }
        });
        if ($scope.template_parent) {
          data['meta'].count += 1;
          $scope.tableFilterSize = data.meta.count;
        }
        $scope.templates = $scope.getProfundity();
        $scope.templates['meta'] = data['meta'];
        if ($scope.templates.length === 0) {
          ngDialog.open({ template: 'views/templates/dialog/no-results.html' });
        }
        defer.resolve($scope.templates);
      },
      function (error) {
        defer.reject(error);
      }
    );
    return defer.promise;
  };

  $scope.$on('templates-status:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('template:updated', function ($event, template) {
    $scope.templateExpanded = null;
    angular.forEach($scope.templates, function (value, key) {
      if (value.id == template.id) {
        $scope.templates[key] = template;
      }
    });
  });

  $controller('TableFilterController', { $scope: $scope });

  if ($stateParams.id) {
    TemplateTriggerService.get($stateParams.id).then(
      function (data) {
        $scope.template_parent = data;
        $rootScope.$broadcast('parent_name', $scope.template_parent);
        $scope.loadPage($scope.page);
      },
      function (error) {
        $scope.loadPage($scope.page);
      }
    );
  }

  $scope.$on('template:created', function () {
    updatetemplatetrigger();
  });

  $scope.$on('template-trigger:created', function () {
    updatetemplatetrigger();
  });

  function updatetemplatetrigger(){
    ngDialog.closeAll();
    $scope.templateExpanded = null;
    $scope.loadPage($scope.page);
  }
};

app.controller('TemplateTriggerList', [
  '$scope',
  '$filter',
  '$timeout',
  '$q',
  '$controller',
  '$stateParams',
  '$rootScope',
  'ngDialog',
  'TemplateService',
  'FilterService',
  '$state',
  'PermissionService',
  'AccountUserService',
  'AuthDataService',
  'TemplateTriggerService',
  TemplateTriggerList
]);
